import React, { useState, useEffect, Fragment } from 'react';
import Header from './Header';
import DefaultSidebar from './Sidebar'
import { Card, Typography, Menu, MenuHandler, MenuList, MenuItem } from "@material-tailwind/react";
import axios from 'axios';
import ModalCreateAnnuaireAlta from './ModalCreateAnnuaireAlta'
import ModalModifyAnnuaireAlta from './ModalModifyAnnuaireAlta';
import ModalModifyAnnuaireAltaClient from './ModalModifyAnnuaireAltaClient'
import { useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function AnnuaireAlta() {
    // const [open, setOpen] = useState('block')
    const [datas, setDate] = useState([])
    const [client, setClient] = useState([])
    // const [videoNames, setVideoNames] = useState([])
    const [sortedBy, setSortedBy] = useState()
    const [counter, setCounter] = useState(0)
    const [search, setSearch] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showModalModify, setShowModalModify] = useState(false);
    const [showModalModifyClient, setShowModalModifyClient] = useState(false);
    const [choosenClientAnnuaireAlta, setchoosenClientAnnuaireAlta] = useState({
        id: '',
        type: '',
        name: '',
        date: '',
        id_anydesk: '',
        password_anydesk: '',
        id_rustdesk: '',
        id_room_pdv: '',
        remarque: '',
        _pin_code:''
    });
    const [choosenAnnuaireAlta, setchoosenAnnuaireAlta] = useState({
        id_client:'',
        nom_client:'',
        email: '', 
        date:'',
        password:''
    });

    const params = useParams();

    const data = {
        id_client: params.id_client
    };

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/get_one_device_annuaire_alta/${data.id_client}`)
            .then(res => {

                setDate(res.data)
            }).catch(err => console.log(err))
    }, [])

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/get_one_client_annuaire_alta/${data.id_client}`)
            .then(res => {
                setClient(res.data)
            }).catch(err => console.log(err))
    }, [])

    const TABLE_HEAD = [
        { key: "type", text: "Type" },
        { key: "name", text: "Nom Client" },
        { key: "date", text: "Date" },
        { key: "id_anydesk", text: "Anydesk ID" },
        { key: "password_anydesk", text: "Anydesk Password" },
        { key: "id_rustdesk", text: "RustDesk ID" },
        { key: "id_room_pdv", text: "Room ID / ID PDV" },
        { key: "remarque", text: "Remarque" },
        { key: "_pin_code", text: "Pin Code" },
        { key: "edit", text: "Edit" },
    ];

    const sorted = datas.sort((a, b) => {

        const aVal = a[sortedBy];
        const bVal = b[sortedBy];
        if (typeof aVal === "number" && typeof bVal === "number") {
            if (counter % 2 === 0) return aVal - bVal;
            else return bVal - aVal;
        }
        else if (typeof aVal === "string" && typeof bVal === "string") {
            if (counter % 2 === 0) return aVal.localeCompare(bVal);
            else return bVal.localeCompare(aVal);
        }
        return 1;
    });

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    // Copie presse-papier + toast (même motif que AnnuaireServer.js).
    // navigator.clipboard exige un contexte sécurisé -> OK ici (cms.alta-pos.fr est en HTTPS).
    const copyToClipboard = (value, message) => {
        navigator.clipboard.writeText(value).then(() => {
            toast.success(message, { position: "bottom-right", autoClose: 2000 });
        }).catch(() => {
            toast.error("Copie impossible (presse-papier refusé par le navigateur)", { position: "bottom-right" });
        });
    };

    // Ouvre l'app RustDesk du poste sur cet ID via son schéma d'URL.
    // Rien ne se passe si RustDesk n'est pas installé (le navigateur ignore un schéma inconnu,
    // sans erreur exploitable) -> on prévient l'utilisateur par un toast.
    const connectRustDesk = (id) => {
        window.location.href = `rustdesk://connection/new/${encodeURIComponent(id)}`;
        toast.info("Ouverture de RustDesk… (rien ne se passe ? vérifie qu'il est installé)", {
            position: "bottom-right", autoClose: 3000,
        });
    };

    const InfoClient = (() => {
        return (
            <div className="flex justify-between items-center w-full px-8">
                {/* Left: Nom Client */}
                <h2 className="font-bold text-xl ">
                    Nom Client: {client[0]?.nom_client}
                </h2>

                {/* Right: Info */}
                <div className="flex items-center gap-4 text-lg">
                    <span>Info:</span>
                    <span>{client[0]?.email}</span>
                    <span>{new Date(client[0]?.date).toLocaleDateString('fr-FR')}</span>
                    <span>{client[0]?.password}</span>

                    {/* Edit Button */}
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-6 h-6 cursor-pointer"
                        onClick={() => {
                            setShowModalModifyClient(true);
                            setchoosenAnnuaireAlta({
                                ...choosenAnnuaireAlta,
                                id_client: client[0]?.id_client,
                                nom_client: client[0]?.nom_client,
                                email: client[0]?.email,
                                date: client[0]?.date,
                                password: client[0]?.password,
                            });
                        }}
                    >
                        <path fillRule="evenodd" clipRule="evenodd" d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V7C19 7.55228 19.4477 8 20 8C20.5523 8 21 7.55228 21 7V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM22.1213 10.7071C20.9497 9.53553 19.0503 9.53553 17.8787 10.7071L16.1989 12.3869L11.2929 17.2929C11.1647 17.4211 11.0738 17.5816 11.0299 17.7575L10.0299 21.7575C9.94466 22.0982 10.0445 22.4587 10.2929 22.7071C10.5413 22.9555 10.9018 23.0553 11.2425 22.9701L15.2425 21.9701C15.4184 21.9262 15.5789 21.8353 15.7071 21.7071L20.5556 16.8586L22.2929 15.1213C23.4645 13.9497 23.4645 12.0503 22.2929 10.8787L22.1213 10.7071ZM18.3068 13.1074L19.2929 12.1213C19.6834 11.7308 20.3166 11.7308 20.7071 12.1213L20.8787 12.2929C21.2692 12.6834 21.2692 13.3166 20.8787 13.7071L19.8622 14.7236L18.3068 13.1074ZM16.8923 14.5219L18.4477 16.1381L14.4888 20.097L12.3744 20.6256L12.903 18.5112L16.8923 14.5219Z" fill="#000000" />
                    </svg>
                </div>
            </div>
        );
    })

    const ListTable = (() => {
        return (
            <Card className="h-full w-full overflow-x-auto">
                {/* <table className="w-fit min-w-max table-auto text-left rounded-2xl"> */}
                <table className="w-full min-w-max text-left ">
                    <thead>
                        <tr className='sticky top-0'>
                            {TABLE_HEAD.map((head) => (
                                <th
                                    key={head.key}
                                    className="border bg-slate-700 text-white p-4 cursor-pointer"
                                    onClick={() => { setSortedBy(head.key); setCounter(counter + 1) }}
                                >
                                    <Typography
                                        variant="small"
                                        className="font-normal leading-none "
                                    >
                                        {head.text}
                                    </Typography>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {sorted.filter((item) => {
                            return search.toLowerCase() === ''
                                ? item
                                : item.name?.toLowerCase().includes(search.toLowerCase()) ||
                                item.type?.toLowerCase().includes(search.toLowerCase()) ||
                                item.id_room_pdv?.toLowerCase().includes(search.toLowerCase()) ||
                                item.id_anydesk?.toLowerCase().includes(search.toLowerCase()) ||
                                item.id_rustdesk?.toLowerCase().includes(search.toLowerCase()) ||
                                item.remarque?.toLowerCase().includes(search.toLowerCase())
                        }).map((data, index) => {
                            const isLast = index === data.length - 1;
                            const classes = isLast ? "p-4" : "p-4 border-b border-blue-slate-50";

                            return (
                                <tr key={data.id} className='cursor-pointer'>
                                    {/* <tr key={data.id} className='w-12' > */}
                                    <td className={classes}>
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {data.type}
                                        </Typography>
                                    </td>
                                    <td className={classes}>
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {data.name}
                                        </Typography>
                                    </td>
                                    <td className={classes}>
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {/* {data.date} */}
                                            {new Date(data.date).toLocaleDateString('fr-FR')}

                                        </Typography>
                                    </td>
                                    <td className={classes}>
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {data.id_anydesk}
                                        </Typography>
                                    </td>
                                    <td className={classes}>
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {data.password_anydesk}
                                        </Typography>
                                    </td>
                                    <td className={classes}>
                                        {data.id_rustdesk ? (
                                            <Menu placement="bottom-start">
                                                <MenuHandler>
                                                    <Typography
                                                        variant="small"
                                                        color="blue-gray"
                                                        className="font-normal cursor-pointer underline decoration-dotted underline-offset-2 hover:text-blue-600"
                                                        title="Cliquer pour copier ou se connecter"
                                                    >
                                                        {data.id_rustdesk}
                                                    </Typography>
                                                </MenuHandler>
                                                <MenuList className="min-w-[14rem]">
                                                    <MenuItem onClick={() => copyToClipboard(data.id_rustdesk, "ID RustDesk copié")}>
                                                        Copier l'ID
                                                    </MenuItem>
                                                    <hr className="my-1" />
                                                    <MenuItem onClick={() => connectRustDesk(data.id_rustdesk)}>
                                                        Se connecter via RustDesk
                                                    </MenuItem>
                                                </MenuList>
                                            </Menu>
                                        ) : (
                                            <Typography variant="small" color="blue-gray" className="font-normal">
                                                {data.id_rustdesk}
                                            </Typography>
                                        )}
                                    </td>
                                    <td className={classes}>
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {data.id_room_pdv}
                                        </Typography>
                                    </td>
                                    <td className={classes}>
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {data.remarque}
                                        </Typography>
                                    </td>
                                    <td className={classes}>
                                        <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal"
                                        >
                                            {data._pin_code}
                                        </Typography>
                                    </td>
                                    <td className={classes}>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6" onClick={() => { setShowModalModify(true); setchoosenClientAnnuaireAlta({ ...choosenClientAnnuaireAlta, id: data.id, type: data.type, name: data.name, date: data.date, id_anydesk: data.id_anydesk, password_anydesk: data.password_anydesk, id_rustdesk: data.id_rustdesk, id_room_pdv: data.id_room_pdv, remarque: data.remarque, _pin_code: data._pin_code }) }}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M5.25 14.25h13.5m-13.5 0a3 3 0 01-3-3m3 3a3 3 0 100 6h13.5a3 3 0 100-6m-16.5-3a3 3 0 013-3h13.5a3 3 0 013 3m-19.5 0a4.5 4.5 0 01.9-2.7L5.737 5.1a3.375 3.375 0 012.7-1.35h7.126c1.062 0 2.062.5 2.7 1.35l2.587 3.45a4.5 4.5 0 01.9 2.7m0 0a3 3 0 01-3 3m0 3h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008zm-3 6h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008z" />
                                        </svg>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </Card>
        );
    })

    return (
        <Fragment>
            <div>
                {/* <Header /> */}
                <div className='max-w-md flex items-center text-center mx-auto my-8 gap-2'>
                    {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 absolute left-1 cursor-pointer" onClick={() => setOpen(open === `hidden` ? 'block' : 'hidden')} >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                    </svg> */}
                    <div className="relative flex items-left w-full h-9 rounded-lg focus-within:shadow-lg bg-slate-700 overflow-hidden">
                        <div className="grid place-items-center h-full w-12 text-slate-50">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                        </div>

                        <input
                            className="h-full w-full outline-none text-white pr-2 bg-slate-700 placeholder-slate-50"
                            type="text"
                            id="search"
                            placeholder="Search something.."
                            onChange={(e) => setSearch(e.target.value)} />
                    </div>
                </div>
                <main className="flex flex-row mt-4">
                    {/* <DefaultSidebar isOpen={open} /> */}
                    <div className="flex flex-col flex-grow">
                        <div className="flex flex-col">
                            {InfoClient()}
                            {ListTable()}
                        </div>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 fixed bottom-16 right-6 cursor-pointer" onClick={() => scrollToTop()}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 fixed bottom-6 right-6 cursor-pointer" onClick={() => setShowModal(true)} >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </main>
            </div>
            <ModalModifyAnnuaireAlta isVisible={showModalModify} onClose={() => setShowModalModify(false)} choosenClientAnnuaireAlta={choosenClientAnnuaireAlta} id_client={data.id_client} />
            <ModalModifyAnnuaireAltaClient isVisible={showModalModifyClient} onClose={() => setShowModalModifyClient(false)} choosenAnnuaireAlta={choosenAnnuaireAlta} />
            <ModalCreateAnnuaireAlta isVisible={showModal} onClose={() => setShowModal(false)} id_client={data.id_client} />
            <ToastContainer />
        </Fragment>

    )
}
export default AnnuaireAlta;